import { DataModelBuilder, SerializationContext, SerializedData } from '../../../dto/data-model.js';
import { Payload } from '../payload.js';
import { PayloadType } from '../payload-type.js';
import { MapUtils } from '../../../../utility/map-utils.js';

export class ConnectionStatusPayload extends Payload {
  static readonly TYPE_ID = '04d3356761f64752a4a3aa3400881bbb';

  private constructor(
    public readonly name: string | null,
    public readonly sessionId: string | null,
  ) {
    super();
  }

  get $typeId(): string {
    return ConnectionStatusPayload.TYPE_ID;
  }

  get type(): PayloadType {
    return PayloadType.Connect;
  }

  static create(args: {
    name: string | null;
    sessionId: string | null;
  }): ConnectionStatusPayload {
    return new ConnectionStatusPayload(args.name, args.sessionId);
  }

  static fromMap(context: SerializationContext, map: SerializedData): ConnectionStatusPayload {
    return ConnectionStatusPayload.create({
      name: MapUtils.getStringOrNull(map, 'name'),
      sessionId: MapUtils.getStringOrNull(map, 'sessionId'),
    });
  }

  toMap(_context: SerializationContext): SerializedData {
    return {
      'name': this.name,
      'sessionId': this.sessionId,
    };
  }

  clone(): this {
    return this.copyWith();
  }

  copyWith({
    name = this.name,
    sessionId = this.sessionId,
  }: {
    name?: string | null;
    sessionId?: string | null;
  } = {}): this {
    return ConnectionStatusPayload.create({ name, sessionId }) as this;
  }

  isSame(other: ConnectionStatusPayload): boolean {
    return this === other || (
      this.name === other.name &&
      this.sessionId === other.sessionId
    );
  }
}

export class ConnectionStatusPayloadBuilder extends DataModelBuilder<ConnectionStatusPayload> {
  build(context: SerializationContext, map: SerializedData): ConnectionStatusPayload {
    return ConnectionStatusPayload.fromMap(context, map);
  }
}
